import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["actions", "children", "spacing"];
import { createButton } from '@flowio/react-button';
import { Box } from '@flowio/react-box';
import React from 'react';

var PageActions = function PageActions(_ref) {
  var _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? [] : _ref$actions,
      children = _ref.children,
      spacing = _ref.spacing,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", unhandledProps, children != null ? children : /*#__PURE__*/React.createElement(Box, {
    spacing: spacing,
    alignItems: "center"
  }, actions.map(function (action) {
    return createButton(action);
  })));
};

export default PageActions;